'use strict';

/**
 * Capitalize the first letter of a single name token; remaining letters lowercase.
 * Supports hyphenated and apostrophe names (Jean-Luc, O'Brien).
 */
function titleCaseToken(token) {
  if (!token) return '';
  const lower = String(token).toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

function titleCaseWord(word) {
  if (!word) return '';
  return String(word)
    .toLowerCase()
    .split('-')
    .map((segment) => segment.split("'").map(titleCaseToken).join("'"))
    .join('-');
}

/**
 * Format a person name: first letter of each name part uppercased, all other letters lowercased.
 * @param {unknown} name
 * @returns {string|null}
 */
function formatPersonName(name) {
  if (name == null) return null;
  const trimmed = String(name).trim().replace(/\s+/g, ' ');
  if (trimmed === '') return null;
  return trimmed.split(' ').map(titleCaseWord).join(' ');
}

module.exports = {
  formatPersonName,
  titleCaseWord,
};
